<div class="voyage-totals-container">
  <div class="voyage-totals-container__item" *ngIf="voyageType === VOYAGE_TYPES.FULL_CONTAINER">
    <span class="label">{{ "MENU.CONTAINERS" | translate }}</span>
    <span class="value">
      {{ totals?.atWarehouse?.containersCount }}
      <span class="value-total">({{ totals?.total?.containersCount }})</span>
    </span>
  </div>
  <div class="voyage-totals-container__item">
    <span class="label">{{ "MENU.SHIPMENTS" | translate }}</span>
    <span class="value">
      {{ totals?.atWarehouse?.shipmentsCount }}
      <span class="value-total">({{ totals?.total?.shipmentsCount }})</span>
    </span>
  </div>
  <div class="voyage-totals-container__item">
    <span class="label">{{ "LABELS.NUMBER_OF_PACKAGES" | translate }}</span>
    <span class="value">
      {{ totals?.atWarehouse?.packagesCount }}
      <span class="value-total">({{ totals?.total?.packagesCount }})</span>
    </span>
  </div>
  <div class="voyage-totals-container__item">
    <span class="label">{{ "LABELS.VOLUME_CBM" | translate }}</span>
    <span class="value">
      {{ totals?.atWarehouse?.volume }}
      <span class="value-total">({{ totals?.total?.volume }})</span>
    </span>
  </div>
  <div class="voyage-totals-container__item">
    <span class="label">{{ "LABELS.WEIGHT_TON" | translate }}</span>
    <span class="value">
      {{ totals?.atWarehouse?.weight }}
      <span class="value-total">({{ totals?.total?.weight }})</span>
    </span>
  </div>
  <div class="voyage-totals-container__item">
    <span class="label">{{ "LABELS.EST_REVENUE" | translate }}</span>
    <span class="value value-blue">
      {{ revenueAtWarehousePrice | currency : "USD" : "symbol" : "1.2-2" }}
      <span class="value-total">({{ revenueTotalPrice | currency : "USD" : "symbol" : "1.2-2" }})</span>
    </span>
  </div>
</div>
